/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-plusplus */
/* eslint-disable react/state-in-constructor */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/static-property-placement */
/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { SingleDatePicker as SingleDatePickerComp } from 'react-dates';
import classNames from 'classnames';
import * as moment from 'moment';
import { getIn } from 'formik';
import {
  ANCHOR_LEFT,
  ANCHOR_RIGHT,
  ICON_AFTER_POSITION,
  ICON_BEFORE_POSITION,
  OPEN_DOWN,
  OPEN_UP,
} from 'react-dates/constants';

import styles from './SingleDatePicker.less';

class SingleDatePicker extends Component {
  static propTypes = {
    field: PropTypes.shape({}).isRequired,
    form: PropTypes.shape({}).isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    displayFormat: PropTypes.string,
    numberOfMonths: PropTypes.number,
    anchorDirection: PropTypes.oneOf([ANCHOR_LEFT, ANCHOR_RIGHT]),
    showClearDate: PropTypes.bool,
    readOnly: PropTypes.bool,
    customInputIcon: PropTypes.node,
    inputIconPosition: PropTypes.oneOf([ICON_BEFORE_POSITION, ICON_AFTER_POSITION]),
    openDirection: PropTypes.oneOf([OPEN_DOWN, OPEN_UP]),
    appendToBody: PropTypes.bool,
  };

  static defaultProps = {
    placeholder: '',
    numberOfMonths: 1,
    displayFormat: 'YYYY-MM-DD',
    anchorDirection: ANCHOR_LEFT,
    showClearDate: false,
    readOnly: false,
    customInputIcon: null,
    inputIconPosition: ICON_AFTER_POSITION,
    openDirection: OPEN_DOWN,
    appendToBody: false,
  };

  state = {
    focused: false,
  };

  onFocusChange = ({ focused }) => {
    this.setState({
      focused,
    });
  };

  onDateChange = dateTime => {
    const {
      field: { name },
      form: { setFieldValue },
      showClearDate,
    } = this.props;

    if (showClearDate && !dateTime) {
      setFieldValue(name, null);
      return;
    }

    dateTime && setFieldValue(name, dateTime);
  };

  renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    let i;
    const years = [];
    for (i = moment().year(); i >= moment().year() - 100; i--) {
      years.push(
        <option value={i} key={`year-${i}`}>
          {i}
        </option>,
      );
    }
    return (
      <div className={styles.wrapMonth} style={{ display: 'flex', justifyContent: 'center' }}>
        <div>
          <select value={month.month()} onChange={e => onMonthSelect(month, e.target.value)}>
            {moment.months().map((label, valueI) => (
              <option value={valueI} key={valueI}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select value={month.year()} onChange={e => onYearSelect(month, e.target.value)}>
            {years}
          </select>
        </div>
      </div>
    );
  };

  render() {
    const { focused } = this.state;

    const {
      label,
      placeholder,
      field: { value, name },
      form: { touched, errors },
      numberOfMonths,
      monthPick,
      showClearDate = false,
      readOnly = false,
      anchorDirection,
      customCloseIcon = null,
      customInputIcon = null,
      inputIconPosition = ICON_AFTER_POSITION,
      openDirection = OPEN_DOWN,
      appendToBody = false,
      ...rest
    } = this.props;
    const touch = getIn(touched, name);
    const errorText = getIn(errors, name);

    return (
      <Form.Field>
        {/* <Form.Field error={touched[name] && errors[name]}> */}
        {label && <span className={classNames(styles.label, 'singleDateLabel')}>{label}</span>}
        <div className={styles.wrap}>
          <div className={styles.datePickerComponent}>
            <SingleDatePickerComp
              hideKeyboardShortcutsPanel
              date={moment(value)?.isValid() ? value : undefined}
              placeholder={placeholder}
              focused={focused}
              onDateChange={this?.onDateChange}
              onFocusChange={this?.onFocusChange}
              numberOfMonths={numberOfMonths}
              anchorDirection={anchorDirection}
              renderMonthElement={monthPick && this.renderMonthElement}
              showClearDate={showClearDate}
              readOnly={readOnly}
              customCloseIcon={customCloseIcon}
              customInputIcon={customInputIcon}
              inputIconPosition={inputIconPosition}
              openDirection={openDirection}
              appendToBody={appendToBody}
              {...rest}
            />
            {touch && errorText && (
              <span style={{ display: 'block', marginTop: 4 }} className={styles.error}>
                {errorText}
              </span>
            )}
          </div>
        </div>
      </Form.Field>
    );
  }
}

export default SingleDatePicker;
